// extracted by mini-css-extract-plugin
module.exports = {"container":"textArea__container___1jKVb","textarea":"textArea__textarea___mz8-B","label":"textArea__label___2T-Kh"};